
const
    ProductLinks = `[ href *= '/products' ]` ,
    ColorSwatch = `.product-item-meta__swatch-list .color-swatch__radio` ,
    Images = `.product-item__primary-image`


const { host } = window.themeVariables.routes

const root = `https://${ host }`


const Component = class
extends CustomHTMLElement {

    connectedCallback (){

        const images = this
            .querySelectorAll(Images)

        this.primaryImageList =
            Array.from(images)


        const onHover = this.#onColorSwatchHovered.bind(this)

        this.delegate.on('mouseenter',ColorSwatch,onHover,true)


        const onChange = this.#onColorSwatchChanged.bind(this)

        this.delegate.on('change',ColorSwatch,onChange)
    }


    #onColorSwatchHovered ( _event , target ){

        const input = target.previousElementSibling

        const featured = input.dataset.variantFeaturedMedia

        if( ! featured )
            return

        const image = this.primaryImageList
            .find(( image ) => image.dataset.mediaId === featured )

        image.setAttribute('loading','eager')
    }


    async #onColorSwatchChanged ( _event , target ){

        const variantId = target.dataset.variantId

        const links = this
            .querySelectorAll(ProductLinks)

        Array
        .from(links)
        .forEach((link) => {

            const href = link.href ??
                link.getAttribute('href')

            const url = new URL(href,root)

            url.searchParams.set('variant',variantId)

            link.setAttribute('href',url.toString())
        })


        const featured = target.dataset.variantFeaturedMedia

        if( ! featured )
            return

        const image = this.primaryImageList
            .find(( image ) => image.dataset.mediaId === featured )

        image.setAttribute('loading','eager')

        const onImageLoaded = ( image.complete )
            ? Promise.resolve()
            : new Promise((resolve) => image.onload = resolve )

        await onImageLoaded

        image.removeAttribute('hidden')

        const Ratios = [
            'aspect-ratio--short' ,
            'aspect-ratio--tall' ,
            'aspect-ratio--square'
        ]

        const hasRatio = Array
            .from(image.parentElement.classList)
            .some(( value ) => Ratios.includes(value))

        const properties = ( hasRatio ) ? [{
            transform : 'translate(calc(-50% - 20px), -50%)' ,
            clipPath : 'polygon(0 0, 0 0, 0 100%, 0% 100%)' ,
            offset : 0 ,
            zIndex : 1
        },{
            transform : 'translate(calc(-50% - 20px), -50%)' ,
            clipPath : 'polygon(0 0, 20% 0, 5% 100%, 0 100%)' ,
            offset : 0.3 ,
            zIndex : 1
        },{
            transform : 'translate(-50%, -50%)' ,
            clipPath : 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' ,
            offset : 1 ,
            zIndex : 1
        }] : [{
            transform : 'translateX(-20px)' ,
            clipPath : 'polygon(0 0, 0 0, 0 100%, 0% 100%)' ,
            offset : 0 ,
            zIndex : 1
        },{
            transform : 'translateX(-20px)' ,
            clipPath : 'polygon(0 0, 20% 0, 5% 100%, 0 100%)' ,
            offset : 0.3 ,
            zIndex : 1
        },{
            transform : 'translateX(0px)' ,
            clipPath : 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' ,
            offset : 1 ,
            zIndex : 1
        }]

        await image.animate(properties,{
            duration : 500 ,
            easing : 'ease-in-out'
        }).finished

        this.primaryImageList
        .filter(( value ) => value != image )
        .filter(( image ) => image.classList.contains(`product-item__primary-image`) )
        .forEach(( image ) => image.setAttribute('hidden','') )
    }
}


window.customElements.define
    ( 'product-item' , Component )
